/* eslint-disable */
import $ from 'jquery';

export class SearchExtFormAutofill {
  constructor() {
    this.$formExtResults = $('.page-template-search-list-ext .text-with-form__wrapper');
    this.$formSelectFields = this.$formExtResults.find('select');
    this.$formDateField = this.$formExtResults.find('.field_date input');
    this.$formOptionsField = this.$formExtResults.find('.field_options textarea');

    // bind event
    this.$formSelectFields.on('change', () => this.updateHiddenField());
    this.$formDateField.on('input', () => this.updateHiddenField());
  }

  updateHiddenField() {
    if (this.$formOptionsField.length) {
      let values = [];

      this.$formSelectFields.each(function () {
        const select = $(this);
        if (select.is(':visible')) {
          values.push(select.val());
        }
      });

      if (this.$formDateField.length && this.$formDateField.is(':visible')) {
        values.push(this.$formDateField.val());
      }

      this.$formOptionsField.val(values.filter(val => val.trim() !== '').join(', '));
    }
  }
}

